import React, { useState } from "react";
import { useAuth } from "../contexts/AuthProvider";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [attempts, setAttempts] = useState(null);

  const { loginAction } = useAuth();

  const langs = navigator.languages || [navigator.language];
  const isGerman = langs.some((l) => String(l).toLowerCase().startsWith("de"));

  async function onSubmit(e) {
    e.preventDefault();
    setErrorMsg("");
    setFieldErrors({});
    setAttempts(null);

    try {
      await loginAction({ email, password });
    } catch (err) {
      console.log("loginPage err:", err, err.status, err.raw);

      const isGerman = navigator.language?.toLowerCase().startsWith("de");

      // lokale Kopien bauen (nicht err mutieren)
      let msg = err.message || "Login fehlgeschlagen.";
      let fe = err.fieldErrors || {};
      let att = err.attempts ?? null;

      if (isGerman) {
        if (msg === "unknown username") {
          msg = "Unbekannter Nutzer.";
        }

        if (msg === "The request is invalid.") {
          //msg = "Passwort falsch.";
          // WICHTIG: fieldErrors.password muss ein Array bleiben
          fe = { ...fe, password: ["Passwort falsch."] };
        }
      }

      setErrorMsg(msg);
      setFieldErrors(fe);
      setAttempts(att);

      console.log("message", msg);
      console.log("fieldErrors", fe);
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
          Chatbot-Analyse-Dashboard
        </h1>

        {errorMsg && (
          <p className="text-red-600 mb-6 text-center">{errorMsg}</p>
        )}

        <form onSubmit={onSubmit}>
          <div className="mb-4">
            <label
              htmlFor="user-email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email:
            </label>

            <input
              id="user-email"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              name="email"
              autoComplete="email"
            />

            {fieldErrors.email && (
              <div className="mt-2 text-sm text-red-600">
                {fieldErrors.email[0]}
              </div>
            )}
          </div>
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Passwort:
            </label>

            <input
              id="password"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              name="password"
              autoComplete="current-password"
            />

            {fieldErrors.password && (
              <div className="mt-2 text-sm text-red-600">
                {fieldErrors.password[0]}
              </div>
            )}
          </div>

          {attempts != null && (
            <div className="mb-4 text-sm text-red-600">
              Versuche: {attempts}
            </div>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700 transition-colors font-medium"
          >
            Anmelden
          </button>
        </form>
      </div>
    </div>
  );
}
export default Login;
